const Slider = [
    {
        id: 1,
        img: 'https://img-c.udemycdn.com/notices/home_carousel_slide/image/fa076447-2355-44bc-bcec-592bbd61d4f3.jpg',
        largeText:'Its the last day to save.',
        miniText:'Expand your horizons with learning that’s worldwide. Log in now to shop the sale.'
    },
    {
        id: 2,
        img: 'https://img-c.udemycdn.com/notices/web_carousel_slide/image/785695e9-5e74-486e-98d5-27354a474246.jpg',
        largeText:'Unlock the power of your people',
        miniText:'Udemy Business is trusted by 12.5K+ companies around the world. Find out what we can do for yours.',
        button:'Request a demo.'
    },
    {
        id: 3,
        img: 'https://img-c.udemycdn.com/notices/web_carousel_slide/image/e6cc1a30-2dec-4dc5-b0f2-c5b656909d5b.jpg',
        largeText:'Learning that gets you',
        miniText:'Skills for your present (and your future). Get started with us.'
    },
    {
        id: 4,
        img: 'https://img-c.udemycdn.com/notices/web_carousel_slide/image/91da579e-8b2c-47b1-b2d7-d3b608e57a7e.png',
        largeText:'Check out our leadership podcast',
        miniText:'Leading Up With Udemy can help you work, lead, and live differently. New episode every Wednesday.',
        button:'Listen Now'
    },


]

export default Slider